import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-table-legend',
  templateUrl: './table-legend.component.html',
  styleUrls: ['./table-legend.component.scss'],
  standalone: false,
})
export class TableLegendComponent {
  private translate = inject(TranslateService);

  @Input()
  items: number[] = [0, 1, 2];

  allValues: { [id: number]: any } = {
    0: {
      label: `= ${this.translate.instant('status.confirmed')}`,
      class: 'green',
      icon: 'checkmark-circle-outline',
    },
    1: {
      label: `= ${this.translate.instant('status.pending')}`,
      class: 'orange',
      icon: 'checkmark-circle-outline',
    },
    2: {
      label: `= ${this.translate.instant('status.error')}`,
      class: 'red',
      icon: 'close-circle-outline',
    },
    3: {
      label: `= ${this.translate.instant('reports.draft')}`,
      class: '',
      icon: 'document-text-outline',
    },
    4: {
      label: `= ${this.translate.instant('machinery.inspected')}`,
      class: 'green',
      icon: 'checkmark-circle-outline',
    },
    5: {
      label: `= ${this.translate.instant('machinery.inspectionNeeded')}`,
      class: 'red',
      icon: 'close-circle-outline',
    },
    6: {
      label: `= ${this.translate.instant('machinery.inspectionNeeded')}`,
      class: 'orange',
      icon: 'checkmark-circle-outline',
    },
    7: {
      label: `= ${this.translate.instant('status.rejected')}`,
      class: 'red',
      icon: 'close-circle-outline',
    },
    8: {
      label: `= ${this.translate.instant('reports.daily')}`,
      class: '',
      icon: 'clipboard-outline',
    },
    9: {
      label: `= ${this.translate.instant('reports.trip')}`,
      class: '',
      icon: 'speedometer-outline',
    },
    10: {
      label: `= ${this.translate.instant('reports.work')}`,
      class: '',
      icon: 'time-outline',
    },
    11: {
      label: `= ${this.translate.instant('hours.workTime')}`,
      class: 'blue',
      icon: 'square',
    },
    12: {
      label: `= ${this.translate.instant('absence.absent')}`,
      class: 'website-orange',
      icon: 'square',
    },
    13: {
      label: `= ${this.translate.instant('common.attachments')}`,
      class: '',
      icon: 'attach-outline',
    },
    14: {
      label: `= ${this.translate.instant('common.hoursNotFull')}`,
      class: 'orange',
      icon: 'timer-outline',
    },
  };
}
